import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class DnDDividerPlacementType extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, DnDDividerPlacementType._types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static TOP_BOTTOM_EDGE = new AString('Top / Bottom edge');
    public static LEFT_RIGHT_EDGE = new AString('Left / Right edge');
    public static CLOSEST_EDGE = new AString('Closest edge');

    private static _types:Array<AString> = [
        DnDDividerPlacementType.TOP_BOTTOM_EDGE,
        DnDDividerPlacementType.LEFT_RIGHT_EDGE,
        DnDDividerPlacementType.CLOSEST_EDGE
    ];

    public static topBottomEdge():DnDDividerPlacementType
    {
        return new DnDDividerPlacementType(DnDDividerPlacementType.TOP_BOTTOM_EDGE);
    }

    public static leftRightEdge():DnDDividerPlacementType
    {
        return new DnDDividerPlacementType(DnDDividerPlacementType.LEFT_RIGHT_EDGE);
    }

    public static closestEdge():DnDDividerPlacementType
    {
        return new DnDDividerPlacementType(DnDDividerPlacementType.CLOSEST_EDGE);
    }

    public static isTopBottomEdge(type:DnDDividerPlacementType):boolean
    {
        return DnDDividerPlacementType.topBottomEdge().isEqualTo(type);
    }

    public static isLeftRightEdge(type:DnDDividerPlacementType):boolean
    {
        return DnDDividerPlacementType.leftRightEdge().isEqualTo(type);
    }

    public static isClosestEdge(type:DnDDividerPlacementType):boolean
    {
        return DnDDividerPlacementType.closestEdge().isEqualTo(type);
    }

    public static fromString(value:string):DnDDividerPlacementType
    {
        return new DnDDividerPlacementType(AString.fromString(value));
    }
}
